module.exports = __webpack_public_path__ + "img/car_4_nissan.241ce95b.jpg";